import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CcfacRange } from '../models';

@Component({
  selector: 'app-cctr-faculty-range',
  templateUrl: './faculty-range.component.html',
})
export class FacultyRangeComponent implements OnInit {
  ccfacRanges: CcfacRange[];

  constructor(private readonly route: ActivatedRoute) {}

  ngOnInit() {
    this.ccfacRanges = null;
    this.updateCcfacRanges();
  }

  updateCcfacRanges() {
    this.route.data.subscribe(({ ccfacRanges }: { ccfacRanges: CcfacRange[]}) => {
      this.ccfacRanges = ccfacRanges;
    });
  }
}
